import {
  NotFoundPage,
  ModalProvider,
  PaginationProvider,
  ViewerContext,
  ModalContext,
  DropdownOptions,
  TooltipPopup,
} from "dash-ui";
import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { ServerErrors } from "dash-common";

import { useGetPropertyByIdQuery } from "gql/generated.graphql";

import { RoutesPath } from "flow-components/routes/routes";
import Header from "flow-components/Header/Header";
import Container from "flow-components/Container/Container";
import PropertyPreview from "containers/properties/PropertyPreview/PropertyPreview";
import AddPropertyToPortfolioModal from "containers/portfolio/AddPorpertyToPortfolioModal/AddPropertyToPortfolioModal";
import PortfolioPropertyPreviewSidebar from "containers/portfolio/PortfolioPropertyPreviewSidebar/PortfolioPropertyPreviewSidebar";
import {
  PropertyPreviewParamsProvider,
  PropertyPreviewParamsContext,
} from "containers/properties/PropertyPreview/context/PropertyPreviewParamsContext";
import UpgradeSubscriptionModal from "common/components/UpgradeSubscriptionModal/UpgradeSubscriptionModal";

import UnavailableProperty from "pages/properties/PropertyPreviewPage/components/UnavailableProperty/UnavailableProperty";
import { SubscriptionChangeConfirmationModal } from "pages/ProfilePage/components/ProfileBilling/components";

function PropertyPreviewAsClient() {
  const { params } = useContext(PropertyPreviewParamsContext);
  const { data, loading, error } = useGetPropertyByIdQuery({
    variables: { propertyId: params.propertyId },
  });
  const property = data?.getPropertyById;
  const navigate = useNavigate();
  const { broker } = useContext(ViewerContext);
  const { upgradeSubscriptionModal } = useContext(ModalContext);

  if (error?.message === ServerErrors.PORTFOLIO_NOT_AVAILABLE && !loading) {
    return (
      <>
        <Header />
        <Container breadcrumbsProps={{ sticky: true }} withSidebar>
          <UnavailableProperty />
        </Container>
      </>
    );
  }
  if (!property && !loading) {
    return <NotFoundPage onRedirect={() => navigate(RoutesPath.Properties)} />;
  }

  return (
    <>
      <Header />
      <DropdownOptions />
      <TooltipPopup />
      <AddPropertyToPortfolioModal />
      <PropertyPreview
        property={property}
        loading={loading}
        isViewAsClient={true}
        isSaleTeamVisible={false}
        leftSideBar={
          <PaginationProvider>
            <PortfolioPropertyPreviewSidebar
              withBreadcrumb={true}
              portfolioFolderId={""}
              brokerId={broker?._id}
              currentPropertyId={params.propertyId}
            />
          </PaginationProvider>
        }
      />
      <SubscriptionChangeConfirmationModal />
      <UpgradeSubscriptionModal type={upgradeSubscriptionModal?.type} />
    </>
  );
}
const PropertyPreviewAsClientPage = () => (
  <PropertyPreviewParamsProvider>
    <ModalProvider>
      <PropertyPreviewAsClient />
    </ModalProvider>
  </PropertyPreviewParamsProvider>
);

export default PropertyPreviewAsClientPage;
